import { render } from "./PaymentHistoryList.vue?vue&type=template&id=7636f0c4&scoped=true"
import script from "./PaymentHistoryList.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryList.vue?vue&type=script&lang=js"

import "./PaymentHistoryList.vue?vue&type=style&index=0&id=7636f0c4&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7636f0c4"]])

export default __exports__